import React, { FC, MouseEvent, ReactElement } from "react";
import { useDispatch } from "react-redux";
import { IconButton } from "@material-ui/core";

import { useRemoveSearchResultButtonStyles } from "./RemoveSearchResultButtonStyles";
import { CloseIcon } from "../../../icons";
import { deleteRecentSearchResult } from "../../../store/ducks/search/actionCreators";
import { SearchTermsRequest } from "../../../store/ducks/search/contracts/state";
import { SEARCH_TERMS, USER_ID } from "../../../constants/common-constants";

interface RemoveSearchResultButtonProps {
    stateItem: "text" | "tags" | "users",
    item: string | number
}

const RemoveSearchResultButton: FC<RemoveSearchResultButtonProps> = ({ stateItem, item }): ReactElement => {
    const classes = useRemoveSearchResultButtonStyles();
    const dispatch = useDispatch();

    const onClickRemoveSearchResult = (event: MouseEvent<HTMLButtonElement>): void => {
        event.stopPropagation();
        dispatch(deleteRecentSearchResult({ stateItem, item }));
        const localStorageItem = localStorage.getItem(SEARCH_TERMS);
        const userId = localStorage.getItem(USER_ID);
        if (localStorageItem && userId) {
          const searchTerms: Record<string, SearchTermsRequest> = JSON.parse(localStorageItem);
  
          // Check if the user ID exists in the stored search terms
          if (searchTerms[userId]) {
            // Explicitly assert the type for the filter operation
            const currentArray = searchTerms[userId][stateItem] as (string | number)[]; // Explicitly type the array
            const newArray = currentArray.filter((storageItem: string | number) => storageItem !== item);

            // Update localStorage with the new search terms for that user
            localStorage.setItem(SEARCH_TERMS, JSON.stringify({
                ...searchTerms,
                [userId]: {
                    ...searchTerms[userId],
                    [stateItem]: newArray
                }
            }));
          }
        }
    };

    return (
        <IconButton className={classes.closeIconButton} onClick={onClickRemoveSearchResult} color="primary">
            {CloseIcon}
        </IconButton>
    );
};

export default RemoveSearchResultButton;
